declare const window: any;

export function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}

export function toString(value: any): string {
  return (value !== undefined && value !== null)
         ? `${value}`
         : '';
}

export function getValueInRange(value: number,
  max: number,
  min = 0): number {
  return Math.max(Math.min(value, max), min);
}

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function isNumber(value: any): value is number {
  return !isNaN(toInteger(value));
}

export function isInteger(value: any): value is number {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

export function isDefined(value: any): boolean {
  return value !== undefined && value !== null;
}

export function padNumber(value: number) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}

export function regExpEscape(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export function hasClassName(element: any,
  className: string): boolean {
  return element && element.className && element.className.split && element.className.split(
    /\s+/).indexOf(className) >= 0;
}

export function getKey(obj: any,
  depth: string): any | null {
  let clone = obj && typeof obj === 'object'
              ? JSON.parse(JSON.stringify(obj))
              : {};
  const notFound = depth.split('.').some(k => {
    const hasProp = clone.hasOwnProperty(k);
    clone = hasProp
            ? clone[k]
            : clone;
    return !hasProp;
  });
  return notFound
         ? null
         : clone;
}

export function leftPad(string,
  pad,
  length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
}

export function calculateAge(birthdate,
  current?) {
  current = Date.parse(current) || Date.now();
  const ageDiffMs = current - new Date(birthdate).getTime();
  const ageDate = new Date(ageDiffMs);

  function monthDiff(d1,
    d2) {
    if (d1 < d2) {
      const months = d2.getMonth() - d1.getMonth();
      return months <= 0
             ? 0
             : months;
    }
    return 0;
  }

  let age: any = Math.abs(ageDate.getUTCFullYear() - 1970);
  if (age === 0) {
    age = monthDiff(birthdate, new Date()) + ' months';
  }
  return age;
}

export function stripDate(date: string = ''): string {
  let retVal = date;
  if (date && date.length > 10) {
    retVal = date.substring(0, 10);
  }
  return retVal;
}

/**
 * remove an element from the DOM
 */
export function removeElement(element) {
  return element && element.parentNode && element.parentNode.removeChild(element);
}

/**
 * Check if valid url
 * used to validate user input from query params
 * https://stackoverflow.com/a/22648406/2698213
 */
export function isURL(str) {
  const urlRegex = '^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?' +
    '(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|' +
    '25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*' +
    '[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*' +
    '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
  const url = new RegExp(urlRegex, 'i');
  return str.length < 2083 && url.test(str);
}

/**
 * returns a string | Id-xxxxxxxxxxxxxxxx
 */
export function generateUUId(prefix = 'Id-'): string {
  const s = [
    1,
    2,
    3
  ].map(i => Math.random().toString(36).slice(2))
    .join('').substring(0, 24);
  return `${prefix}${s}`;
}

/**
 * Check value for null or empty values that may come from CVS APIs
 */
export function isNullOrEmpty(val: any): boolean {
  return (val === '' || val === null || val === 'null');
}

/**
 * Leftpad a number
 * @param n - The number to be padded
 * @param width - the number of leading zeros
 * @param z - the symbole to be prepended
 *
 * @Usage
 * leftPadNum('1', 2) -> 01
 * leftPadNum('01', 3) -> 001
 */
export function leftPadNum(n: string,
  width: number,
  z: string = '0'): string {
  n += '';
  return n.length >= width
         ? n
         : new Array(width - n.length + 1).join(z) + n;
}

/**
 * Parse queryParameters from URL
 * Used to get query parameters outside of Angular
 */
export function queryParamToObject(): any | {} {
  const queryStr = window.location.href.split('?')[1];
  const query = {};
  if (!queryStr) {
    return query;
  }
  const a = queryStr.split('&');
  a.forEach(k => {
    const p = k.split('=');
    const key = p[0];
    const val = p[1];
    query[key] = val;
  });
  return query;
}

/**
 * Parse queryParameters from URL
 * Used to get query parameters outside of Angular
 */
export function queryParamObjectToString(params = {}): string {
  let qs = '';
  if (Object.keys(params).length) {
    for (const k in params) {
      if (params.hasOwnProperty(k)) {
        qs += `${k}=${params[k]}`;
      }
    }
  }
  return qs;
}

/**
 * Detect is application is running in CVS APP
 */
export function isMobileApp(): boolean {
  if (window.native) {
    return true;
  }
  const ua = (navigator && navigator.userAgent);
  return ua && [
    'CVS_iPHONE_APP',
    'CVS_iPAD_APP',
    'CVS_ANDROID_APP'
  ].some(a => ua.toLowerCase().indexOf(a.toLowerCase()) > -1);
}
